var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreferences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3C2 2.44771 2.44772 2 3 2L16 2C16.5523 2 17 2.44772 17 3C17 3.55229 16.5523 4 16 4L3 4C2.44771 4 2 3.55228 2 3Z",
    fill: "#003393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 17C1 16.4477 1.44772 16 2 16L16 16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18L2 18C1.44771 18 1 17.5523 1 17Z",
    fill: "#003393"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10C1 9.44771 1.44772 9 2 9L16 9C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11L2 11C1.44771 11 1 10.5523 1 10Z",
    fill: "#003393"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 3,
    r: 2,
    fill: "white",
    stroke: "#003393",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 10,
    r: 2,
    fill: "white",
    stroke: "#003393",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 2,
    fill: "white",
    stroke: "#003393",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.f0fb5952de1f2cf0a4403bd9c2eac2a3.svg";
export { ForwardRef as ReactComponent };